import {
  CheckboxIcon,
  ConditionIcon,
  ImageIcon,
  InputIcon,
  NumberIcon,
  OtherFieldsIcon,
  RadioIcon,
  SelectIcon,
  TextareaIcon,
} from '../../icons';

export const FIELD_PICKER_DATA = [
  {
    icon: RadioIcon,
    type: 'radio',
    field_type: 'radio',
    tooltip: 'radioField',
  },
  {
    icon: ImageIcon,
    type: 'multiple_photo',
    field_type: 'multiple_photo',
    tooltip: 'imageField',
  },
  {
    icon: InputIcon,
    type: 'text',
    field_type: 'text',
    tooltip: 'inputField',
  },
  {
    icon: NumberIcon,
    type: 'number',
    field_type: 'numeric',
    tooltip: 'numericField',
  },
  {
    icon: SelectIcon,
    type: 'select',
    field_type: 'select',
    tooltip: 'selectField',
  },
  {
    icon: ConditionIcon,
    type: 'condition_code',
    field_type: 'condition_code',
    tooltip: 'conditionCodeField',
  },
];
